import React, { useEffect, useState } from 'react';

// TM RUSH internal login: Maurício (e-mail + password opens the Comando, the team panel and the Desk) and the team (marcasja.br@gmail.com opens the team panel).
// The password is set by the owner through a link sent to his e-mail (/entrar#r=<token>); it is never typed in here by anyone else.
const API = 'https://n8n-hag0.srv1897462.hstgr.cloud/webhook';
const STORES = { cmd: 'tmr_cmd_key', ops: 'tmr_ops_key', desk: 'tmr_desk_key' };

const readReset = () => {
  try {
    const m = window.location.hash.match(/r=([A-Za-z0-9_-]+)/);
    if (m) {
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      return m[1];
    }
  } catch (e) { /* ignore */ }
  return '';
};

const nextPage = (keys) => {
  const can = { '/comando': keys.cmd, '/ops': keys.ops, '/desk': keys.desk };
  let q = '';
  try { q = new URLSearchParams(window.location.search).get('ir') || ''; } catch (e) { /* ignore */ }
  if (can[q]) return q;
  return keys.cmd ? '/comando' : '/ops';
};

const post = async (path, body) => {
  const r = await fetch(`${API}/${path}`, { method: 'POST', body: new URLSearchParams(body) });
  const j = await r.json().catch(() => ({}));
  if (!j.ok) throw new Error(j.error || 'Não deu certo. Tente de novo em instantes.');
  return j;
};

const input = 'w-full rounded-xl border border-gray-200 px-3 py-3 text-base focus:outline-none focus:border-primary';
const button = 'w-full bg-primary text-white font-semibold rounded-xl px-4 py-3 hover:bg-primary-hover disabled:opacity-50';

const EntrarPage = () => {
  const [reset] = useState(readReset);
  const [mode, setMode] = useState(reset ? 'set' : 'login');
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    const prev = document.title;
    document.title = 'Entrar | TM RUSH';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);
    return () => {
      document.title = prev;
      document.head.removeChild(meta);
    };
  }, []);

  const enter = async (em, p) => {
    const j = await post('tmr-auth-login', { email: em, password: p, kind: 'master' });
    const keys = j.keys || {};
    try { Object.entries(STORES).forEach(([k, store]) => { if (keys[k]) localStorage.setItem(store, keys[k]); }); } catch (e) { /* storage blocked */ }
    window.location.assign(nextPage(keys));
  };

  const run = (fn) => async (e) => {
    e.preventDefault();
    setErr('');
    setBusy(true);
    try { await fn(); } catch (ex) { setErr(ex.message); } finally { setBusy(false); }
  };

  const onLogin = run(() => enter(email.trim(), pw));
  const onForgot = run(async () => { await post('tmr-auth-reset', { email: email.trim(), kind: 'master' }); setMode('sent'); });
  const onSet = run(async () => {
    if (pw.length < 8) throw new Error('Use pelo menos 8 caracteres.');
    if (pw !== pw2) throw new Error('As duas senhas não são iguais.');
    const j = await post('tmr-auth-set', { token: reset, password: pw });
    await enter(j.email, pw);
  });

  return (
    <main className="min-h-screen bg-background flex items-center justify-center px-4 py-10">
      <div className="bg-background-white rounded-2xl p-7 md:p-8 max-w-md w-full shadow-sm border border-gray-100/80">
        <img src="/images/tm-rushlogo.svg" alt="TM RUSH" className="h-7 mb-6" />
        {mode === 'login' && (
          <form onSubmit={onLogin} className="space-y-4">
            <div>
              <h1 className="text-xl font-bold text-text mb-1">Entrar</h1>
              <p className="text-sm text-text/60">Comando e painel da equipe da TM RUSH.</p>
            </div>
            <label className="block text-sm font-semibold text-text" htmlFor="em">E-mail
              <input id="em" type="email" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${input} mt-1 font-normal`} />
            </label>
            <label className="block text-sm font-semibold text-text" htmlFor="pw">Senha
              <input id="pw" type="password" autoComplete="current-password" required value={pw} onChange={(e) => setPw(e.target.value)} className={`${input} mt-1 font-normal`} />
            </label>
            {err && <div className="text-sm text-red-700 bg-red-50 rounded-lg px-3 py-2">{err}</div>}
            <button type="submit" disabled={busy || !pw} className={button}>{busy ? 'Entrando…' : 'Entrar'}</button>
            <button type="button" onClick={() => { setErr(''); setMode('forgot'); }} className="w-full text-sm font-semibold text-primary-dark hover:underline">Criar ou trocar a senha</button>
          </form>
        )}
        {mode === 'forgot' && (
          <form onSubmit={onForgot} className="space-y-4">
            <div>
              <h1 className="text-xl font-bold text-text mb-1">Criar ou trocar a senha</h1>
              <p className="text-sm text-text/60">Mandamos um link para o teu e-mail. Ele vale por 1 hora.</p>
            </div>
            <label className="block text-sm font-semibold text-text" htmlFor="em2">E-mail
              <input id="em2" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${input} mt-1 font-normal`} />
            </label>
            {err && <div className="text-sm text-red-700 bg-red-50 rounded-lg px-3 py-2">{err}</div>}
            <button type="submit" disabled={busy} className={button}>{busy ? 'Enviando…' : 'Mandar o link'}</button>
            <button type="button" onClick={() => setMode('login')} className="w-full text-sm text-text/60 hover:underline">Voltar</button>
          </form>
        )}
        {mode === 'sent' && (
          <div className="space-y-4">
            <h1 className="text-xl font-bold text-text">Confira o teu e-mail</h1>
            <p className="text-sm text-text/70">Se o e-mail tem acesso ao painel, o link chega em até 1 minuto. Abra o link e escolha a senha.</p>
            <button type="button" onClick={() => setMode('login')} className="text-sm font-semibold text-primary-dark hover:underline">Voltar para entrar</button>
          </div>
        )}
        {mode === 'set' && (
          <form onSubmit={onSet} className="space-y-4">
            <div>
              <h1 className="text-xl font-bold text-text mb-1">Escolha a tua senha</h1>
              <p className="text-sm text-text/60">Pelo menos 8 caracteres. Use uma senha que você não usa em outro lugar.</p>
            </div>
            <label className="block text-sm font-semibold text-text" htmlFor="np">Nova senha
              <input id="np" type="password" autoComplete="new-password" required value={pw} onChange={(e) => setPw(e.target.value)} className={`${input} mt-1 font-normal`} />
            </label>
            <label className="block text-sm font-semibold text-text" htmlFor="np2">Repita a senha
              <input id="np2" type="password" autoComplete="new-password" required value={pw2} onChange={(e) => setPw2(e.target.value)} className={`${input} mt-1 font-normal`} />
            </label>
            {err && <div className="text-sm text-red-700 bg-red-50 rounded-lg px-3 py-2">{err}</div>}
            <button type="submit" disabled={busy || !pw || !pw2} className={button}>{busy ? 'Salvando…' : 'Salvar e entrar'}</button>
          </form>
        )}
      </div>
    </main>
  );
};

export default EntrarPage;
